module.exports = __webpack_public_path__ + "img/1-1Z21420404UL.906cb40d.png";